import { Timeline } from '@cinematic-engine/timeline';
import { parseProject } from './validate';
export function compileProject(input) {
    const parsed = parseProject(input);
    if (!parsed.success || !parsed.data) {
        return {
            ok: false,
            errors: parsed.issues.map((i) => `${i.path}: ${i.message}`),
            project: null,
        };
    }
    const project = parsed.data;
    const compiledScenes = project.scenes.map((scene) => {
        const compiledShots = scene.shots.map((shot) => ({
            id: shot.id,
            start: shot.start,
            duration: shot.duration,
            purpose: shot.purpose,
            emotion: shot.emotion,
            energy: shot.energy,
            camera: shot.camera ?? null,
            subjects: shot.subjects,
            environment: shot.environment,
            effects: shot.effects,
            typography: shot.typography,
            audio: shot.audio.map((clip) => ({
                assetId: clip.assetId,
                start: clip.start,
                duration: clip.duration,
                gain: clip.gain,
                track: clip.track,
                fadeIn: clip.fadeIn,
                fadeOut: clip.fadeOut,
                loop: clip.loop,
            })),
            transition: shot.transition ?? null,
        }));
        return {
            id: scene.id,
            title: scene.title,
            duration: scene.duration ?? compiledShots.reduce((acc, s) => acc + s.duration, 0),
            shots: compiledShots,
            style: scene.style,
        };
    });
    const totalDuration = compiledScenes.reduce((acc, s) => acc + s.duration, 0);
    const durationFrames = Math.round(totalDuration * project.format.fps);
    const timeline = new Timeline({
        fps: project.format.fps,
        durationFrames,
    });
    return {
        ok: true,
        project: {
            id: project.id,
            metadata: project.metadata,
            format: project.format,
            style: project.style,
            assets: project.assets,
            scenes: compiledScenes,
            audio: project.audio,
            responsive: project.responsive,
            durationSeconds: totalDuration,
            durationFrames,
            timeline,
        },
        errors: [],
    };
}
export function buildProject(input) {
    const result = compileProject(input);
    if (!result.ok || !result.project) {
        throw new Error(`Failed to compile project: ${result.errors.join('; ')}`);
    }
    return result.project;
}
//# sourceMappingURL=compiler.js.map